import Team1 from "../assets/image/team1.png"
import Team2 from "../assets/image/team2.png"
import Team3 from "../assets/image/team3.png"
import { useEffect, useState, useRef } from "react";

export default function Team() {
   const cardRefs = useRef([]);
    const headlineRef = useRef(null);
    const descriptionRef = useRef(null);
  
    
    useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-show");
          }
        });
      },
      { threshold: 0.3 }
    );
  
    // Observe loan cards
    cardRefs.current.forEach((el) => {
      if (el) observer.observe(el);
    });
  
    // Observe headline
    if (headlineRef.current) observer.observe(headlineRef.current);
     if (descriptionRef.current) observer.observe(descriptionRef.current);
  
    return () => observer.disconnect();
  }, []);

  return (
    <>
     <style>{`.card-base {
          transition: opacity 0.3s ease-out;
        }

        .animate-show {
          animation: floatIn 1s ease-out both;
          opacity: 1;
        }

        @keyframes floatIn {
          0% {
            opacity: 0;
            transform: translateY(30px) scale(0.95);
          }
          100% {
            opacity: 1;
            transform: translateY(0px) scale(1);
          }
        }

        .word-animate {
          display: inline-block;
          opacity: 0;
          transform: translateY(20px);
        }

        .animate-show .word-animate {
          animation: wordReveal 0.4s ease-out forwards;
        }
       

        @keyframes wordReveal {
          0% {
            opacity: 0;
            transform: translateY(20px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    <section id='team' className="py-[60px] sm:py-[60px] md:py-[40px] lg:py-[72px] ">
        <div className="max-w-[1280px] flex flex-col mx-auto gap-[60px] px-5  sm:px-6 md:px-10 lg:px-12">
          <div className='  flex flex-col  mx-auto -mb-4 sm:-mb-6 lg:-mb-4 max-w-[322px] sm:max-w-[402px] md:max-w-[460px] lg:max-w-[582px]'>

              <div className="flex justify-center  items-center  mb-6">
              <div ref={descriptionRef}
                    className=" headline-animate w-fit h-fit  border-[#0BA36C] border-[1.5px] rounded-tl-[21px] rounded-tr-[6px] rounded-bl-[5px] rounded-br-[6px] pt-[4px] pr-[16px] pl-[16px] pb-[5px] ">
                <span className=" text-[#0BA36C] text-[16px] font-inter font-semibold">Team</span>
              </div>
            </div>
            
                  
                                        <h2
  ref={headlineRef}
className=" card-base  text-[28px] leading-[36px]  font-poppins  sm:text-[30px]  md:text-[48px] lg:text-[48px] sm:leading-[36px] md:leading-[50px] lg:leading-[62px] font-medium  -tracking-[4%] text-gray-900 mb-4 text-center">
  {["About", "the"].map((word, i) => (
    <span
      key={i}
      className="word-animate"
      style={{ animationDelay: `${i * 0.08}s` }}
    >
      {word}&nbsp;
    </span>
  ))}

  <br/>

  
    <span
    
      className="word-animate text-[#0BA36C]"
      style={{ animationDelay: `${ 0.08}s` }}
    >
      Founders
    </span>
  

  
</h2> 
          
          
          </div >

        <div className="flex flex-col gap-[54px] sm:gap-[62px] md:gap-[62px] lg:gap-[62px]">
          
            <div className=" rounded-3xl p-0 md:p-0">
              <div className="grid md:grid-cols-2 gap-[18px] sm:gap-[18px] md:gap-[62px] lg:gap-[99px] items-center">
                
                <div className="order-1 md:order-1">
                  <img src={Team1}   className="rounded-3xl w-full h-auto object-cover"
/>
                </div>
                <div className="order-2 md:order-2">
                  <h3 className=" text-[46px] md:text-[54px] lg:text-[94px] font-semibold tracking-tight text-black mb-4">Rajiv Talreja</h3>
                  <p className="text-[16px] text-[#7C7C7C] sm:text-[16px] md:text-[16px] lg:text-[16px] leading-relaxed mb-4">
                   A leading voice in the MSME space, Rajiv has worked with thousands of small business owners to help them scale sustainably. His experience brings a deep understanding of real challenges faced by business owners seeking fast and reliable funding.
                  </p>
                </div>
              </div>
            </div>
         


          <div className="grid md:grid-cols-2 gap-[54px] md:gap-[62px] lg:gap-[113px]">
            


            <div className=" flex flex-col rounded-3xl p-0 gap-[32px]">
                <div >
<img
  src={Team3}
  className="rounded-3xl w-full h-auto object-cover"
  alt=""
/>
                </div>         
                <div>
                <h3 className="text-[29.63px] font-semibold text-black mb-3">Karan Hasija</h3>
              <p className="text-[#7C7C7C] text-[16px] leading-relaxed">
With hands-on expertise in business operations and performance 
growth, Karan has helped entrepreneurs across 190+ industries build 
stronger systems, making him a key driver in designing finance 
solutions that actually work for MSMEs.             </p>
              </div>
            </div>
            <div className=" flex flex-col rounded-3xl p-0 gap-[32px]">
                <div >
                  <img src={Team2}   className="rounded-3xl w-full h-auto object-cover"
/>
                </div>         
                <div>
                <h3 className="text-[29.63px] font-semibold text-black mb-3">Akash Kedia</h3>
              <p className="text-[#7C7C7C] text-[16px] leading-relaxed">
Akash is a seasoned fintech leader with over a decade of experience 
in building credit and lending products. He has led key innovations at 
Flipkart, including No-Cost EMIs and Pay Later, and served as Chief 
Product Officer at CheQ, driving credit solutions for millions in India.              </p>
              </div>
            </div>
            </div>
          </div>
        </div>
      </section>
      </>
  );
}